
declare global {
  interface Window {
    $: any;
    jQuery: any;
  }
}
import { Component, Vue } from "vue-property-decorator";
import "air-datepicker/dist/css/datepicker.min.css";
import moment from "moment";

const $ = require("jquery");
window.$ = $;
window.jQuery = $;
require("air-datepicker");

@Component({
  components: {
    Selectize: () => import("vue2-selectize"),
    Slick: () => import("vue-slick")
  },
  computed: {
    isMobile() {
      return window.innerWidth < 992;
    }
  }
})
export default class CompaniesAdd extends Vue {
  title: string = "Agregar Contrato";
  subtitle: string = "Introduzca los datos de la empresa a dar de alta.";
  company: Record<string, any> = {
    handle_exclusion_contract: 0,
    countryId: "",
    renovation_company: "",
    adminId: ""
  };
  totalBranches: any = [];
  companyReinsurers: any = [];
  reinsurers: any = [];
  branches: any = [];
  companies: any = [];
  countries: any = [];
  steps: Record<number, boolean> = {
    0: true,
    1: false,
    2: false
  };
  selectizeOptions: Record<string, any> = {
    delimiter: ",",
    persist: false
  };
  slickOptions: Record<string, any> = {
    slidesToShow: 3,
    centerPadding: "60px",
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          arrows: false,
          dots: false
        }
      }
    ]
  };
  selected: any = [];

  totalPercent(id: any) {
    return 0;
  }

  isBranchChecked(reinsurer: any, value: string) {
    return (
      reinsurer &&
      reinsurer.branches &&
      reinsurer.branches.length &&
      reinsurer.branches.indexOf(value) >= 0
    );
  }

  selectAllBranches(value: boolean, index: number) {
    document
      .querySelectorAll(`[name="branches${index}[]"]`)
      .forEach((i: any) => (i.checked = value));
    this.calculatePercent();
  }

  branch(index: string) {
    const _this: any = this;
    const found = _this.branches.find((b: any) => parseInt(b.id) === parseInt(index));
    return found ? found.title : index;
  }

  validateStep1() {
    const required = ["name", "rif", "direction", "cap"];
    for (let i: number = 0; i < required.length; i++) {
      if (!this.company[required[i]]) return false;
    }
    return true;
  }

  validateStep2() {
    const required = ["owner", "email"];
    for (let i: number = 0; i < required.length; i++) {
      if (!this.company[required[i]]) return false;
    }
    return true;
  }

  move(index: number) {
    if (this[`validateStep${index}`]()) {
      (this.$refs.slick as any).goTo(index);
      this.steps[index] = true;
    }
  }

  async save() {
    let response: any = null;
    if (this.company.adminId == "null") this.company.adminId = null;
    if (this.$route.params.id) {
      response = await (this.$root as any)._put(
        `companies/${this.$route.params.id}`,
        this.company
      );
    } else {
      response = await (this.$root as any)._post("companies", this.company);
    }
    let companyId = response.id;

    // add usefull branches
    for (let i: number = 0; i < this.selected.length; i++) {
      await (this.$root as any)._post("companiesbranches", {
        branchId: this.selected[i],
        companyId: companyId,
        _limit: 0,
        allow_new_request: 1
      });
    }

    // remove useless branches
    if (this.$route.params.id) {
      let removeBranches: any[] = this.branches.filter((item: any) => {
        return this.selected.indexOf(String(item.id)) === -1;
      });

      for (let i: number = 0; i < removeBranches.length; i++) {
        try {
          await (this.$root as any)._delete(
            `companiesbranches/${this.$route.params.id}/${removeBranches[i].id}`
          );
        } catch (e) {
          // i dont care if it fails
        }
      }

      if (this.totalBranches.some(tb => tb.total !== 100)) {
        (this.$root as any).notify(
          "El total de porcentaje tiene que ser 100% para todos los ramos",
          "error"
        );
        return;
      }

      for (let i: number = 0; i < this.totalBranches.length; i++) {
        if (this.totalBranches[i].total === 0) {
          (this.$root as any).notify(
            "Los reaseguradores seleccionados no pueden tener porcentaje igual a 0 o vacio",
            "error"
          );
          return;
        }
      }

      for (let i: number = 0; i < this.companyReinsurers.length; i++) {
        try {
          await (this.$root as any)._delete(
            `reinsurerscompanies/${this.$route.params.id}/${this.companyReinsurers[i].reinsurerId}`
          );
        } catch (e) {
          // i dont care if it fails
        }
      }

      for (let i: number = 0; i < this.reinsurers.length; i++) {
        try {
          if (this.reinsurers[i].checked) {
            let branches: any = [];
            document
              .querySelectorAll(`[name="branches${this.reinsurers[i].id}[]"]`)
              .forEach((i: any) => i.checked && branches.push(i.value));

            await (this.$root as any)._post(`reinsurerscompanies`, {
              reinsurerId: parseInt(this.reinsurers[i].id),
              companyId: companyId,
              percent: parseFloat(this.reinsurers[i].percent) || 100,
              branches: branches.map((b: any) => {
                return {
                  [b]: (document as any).getElementById(
                    `branch-percent-${parseInt(this.reinsurers[i].id)}${b}`
                  ).value
                };
              })
            });
          }
        } catch (e) {
          // i dont care if it fails
        }
      }
    }

    this.$router.push("/admin/companies");
  }

  async init() {
    const _this = this;
    $(".calendar").each(function(this: any) {
      let elem = $(this).find("input");
      elem.datepicker({
        language: "es",
        autoClose: true,
        onSelect: function onSelect(fd, date) {
          _this.company[elem.attr("model")] = moment(date).format("YYYY-MM-DD");
        }
      });
    });
    await this.loadCountries();
    await this.loadCompanies();
    await this.loadBranches();
    await this.loadReinsurers();
    if (this.$route.params.id) {
      this.loadCompany();
    }

    setTimeout(() => {
      this.calculatePercent();
    }, 1000);
  }

  async loadBranches() {
    const response: any = await (this.$root as any)._get("branches");
    this.branches = response.data;
  }

  async loadCountries() {
    const response: any = await (this.$root as any)._get("countries/all");
    this.countries = response.data;
  }

  async loadCompanies() {
    const response: any = await (this.$root as any)._post("companies/all");
    this.companies = response.data;
  }

  async loadReinsurers() {
    let reinsurers: any = await (this.$root as any)._get(
      "reinsurers"
    );

    let companyReinsurers: any = await (this.$root as any)._get(
      `reinsurerscompanies/${this.$route.params.id}`
    );

    reinsurers = reinsurers.data;
    companyReinsurers = companyReinsurers.data;

    reinsurers.forEach(reinsurer => {
      companyReinsurers.forEach(companyReinsurer => {
        if (companyReinsurer.reinsurerId == reinsurer.id) {
          reinsurer.percent = companyReinsurer.percent;
          reinsurer.checked = true;
          reinsurer.branches = JSON.parse(companyReinsurer.branches);
          setTimeout(() => {
            if (reinsurer.branches) {
              reinsurer.branches.forEach(b => {
                if (typeof b === "object") {
                  let key = Object.keys(b)[0];
                  (document as any).getElementById(
                    `branch-${reinsurer.id}${key}`
                  ).checked = true;
                  (document as any).getElementById(
                    `branch-percent-${reinsurer.id}${key}`
                  ).value = b[key];
                } else {
                  (document as any).getElementById(
                    `branch-${reinsurer.id}${b}`
                  ).checked = true;
                  (document as any).getElementById(
                    `branch-percent-${reinsurer.id}${b}`
                  ).value = 100;
                }
              });
            }
          }, 800);
        }
      });
    });

    this.companyReinsurers = companyReinsurers;
    this.reinsurers = reinsurers;
  }

  async loadCompany() {
    const response: any = await (this.$root as any)._post(
      `companies/one/${this.$route.params.id}`,
      {
        models: "branches,admin"
      }
    );
    
    this.company = response.data[0];

    this.company.branches.forEach((cb: any) => {
      if (!this.branches.find((b: any) => b.id === cb.id)) {
        this.branches.push(cb);
      }
    });

    this.title = "Actualizar Contrato";
    this.subtitle = "Modifique los datos a actualizar.";
    this.steps[1] = true;
    this.steps[2] = true;
    this.company.handle_exclusion_contract = response.data[0]
      .handle_exclusion_contract
      ? 1
      : 0;

    let datepicker = $("#date_contract_aon")
      .datepicker()
      .data("datepicker");
    let date = moment(this.company.date_contract_aon);
    
    if (date.isValid()) {
      datepicker.selectDate(date.add(1, 'day').toDate());
    }

    datepicker = $("#date_request_from")
      .datepicker()
      .data("datepicker");
    date = moment(this.company.date_request_from);
    if (date.isValid()) {
      datepicker.selectDate(date.add(1, 'day').toDate());
    }

    datepicker = $("#date_request_to")
      .datepicker()
      .data("datepicker");
    date = moment(this.company.date_request_to);
    
    if (date.isValid()) {
      datepicker.selectDate(date.add(1, 'day').toDate());
    }

    const selectize = (this.$refs.selectize as any).$el.selectize;

    await this.$nextTick();

    this.branches.forEach((b: any) => {
      if (!selectize.options[String(b.id)]) {
        selectize.addOption({ value: String(b.id), text: b.title });
      }
    });

    selectize.setValue(
      this.company.branches.map((item: any) => {
        return String(item.id);
      })
    );

    this.totalBranches = this.company.branches.map((item: any) => {
      return {
        ...item,
        total: 0
      };
    });
  }

  mounted() {
    (this as any).$root.localizeDatepicker($);
  }

  calculatePercent() {
    this.totalBranches.forEach((b, index) => {
      this.totalBranches[index].total = 0;
      this.reinsurers.forEach((r, index2) => {
        let checkbox = (document as any).getElementById(
          `branch-${r.id}${b.id}`
        );
        let input = (document as any).getElementById(
          `branch-percent-${r.id}${b.id}`
        );
        if (r.checked && checkbox && checkbox.checked) {
          this.totalBranches[index].total += parseFloat(input.value);
        }
      });
    });
  }
}
